import { styled } from '@mui/material';
import { PickersDay } from '@mui/x-date-pickers';
import { COLORS } from './constants';

// Extend PickersDayProps to include highlightLevel
interface StyledPickersDayProps {
  highlightLevel?: 'low' | 'medium' | 'high';
}

export const StyledPickersDay = styled(PickersDay, {
  shouldForwardProp: (prop) => prop !== 'highlightLevel',
})<StyledPickersDayProps>(({ highlightLevel }) => ({
  ...(highlightLevel === 'low' && {
    backgroundColor: COLORS.low,
    color: '#fff',
    '&:hover': {
      backgroundColor: `${COLORS.low}cc`,
    },
  }),
  ...(highlightLevel === 'medium' && {
    backgroundColor: COLORS.medium,
    color: '#fff',
    '&:hover': {
      backgroundColor: `${COLORS.medium}cc`,
    },
  }),
  ...(highlightLevel === 'high' && {
    backgroundColor: COLORS.high,
    color: '#fff',
    '&:hover': {
      backgroundColor: `${COLORS.high}cc`,
    },
  }),
}));
